import React from "react";


// eslint-disable-next-line react/display-name
const Menu = React.forwardRef(({ className, ...props },ref) => 
(
<div
    {...props}
    ref={ref}
    className={`inline-block`}
  />
))

// eslint-disable-next-line react/display-name
const Toolbar = React.forwardRef(({ className, ...props },ref) => 
(
<Menu
    {...props}
    ref={ref}
    className={
        `${className} relative pt-[1px] pr-[18px] pb-[17px] mx-[-20px] border-b-[2px] border-black mb-[20px]`
        }
  />
))

export {Toolbar, Menu}